import { Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy, OnInit } from "@angular/core";
import { ObjectNames } from "src/app/configurations/inventory/constants/constants";
import { ImportserialService } from "../../services/importserial.service";
import { Subject, takeUntil } from "rxjs";
import { Fee, Currency, FeeOrDiscountContext, DialogTypeFeeOrDiscount } from "./models/fee.model";
import { DialogType } from "src/app/inventory/sales-order/constants/constants";

@Component({
    selector: "app-fees-and-discounts-manager",
    templateUrl: "./fees-and-discounts-manager.component.html",
})
export class FeesAndDiscountsManagerComponent implements OnInit, OnDestroy {
    @Input({ required: true }) visible!: boolean;
    @Input({ required: true }) dialogType!: DialogType;
    @Input({ required: true }) context!: FeeOrDiscountContext;
    @Input({ required: true }) sectionType!: DialogTypeFeeOrDiscount;
    @Input({ required: true }) feesList: Fee[] = [];
    @Input({ required: true }) selectedFee!: Fee | null;

    @Output() onClose = new EventEmitter<void>();
    @Output() onApply = new EventEmitter<Fee>();

    readonly FeeOrDiscountContext = FeeOrDiscountContext;
    readonly DialogTypeFeeOrDiscount = DialogTypeFeeOrDiscount;
    readonly discountConstantsProperty = ObjectNames.setupConstants;
    readonly ngUnsubscribe$ = new Subject<void>();
    baseCurrency: Currency | null = null;
    tempSelectedFee: Fee | null = null;

    constructor(private importService: ImportserialService) {}

    ngOnInit(): void {
        this.getBaseCurrency();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ("selectedFee" in changes) {
            this.tempSelectedFee = this.selectedFee ?? null;
        }
    }

    handleApply(): void {
        this.onApply.emit(this.tempSelectedFee);
    }

    handleCancel(): void {
        this.onClose.emit();
    }

    private getBaseCurrency(): void {
        this.importService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (Array.isArray(value)) {
                    this.baseCurrency = (value as Currency[]).find((cr) => cr?.isBaseCurrency) ?? null;
                }
            });
    }

    get headerLabel(): string {
        return this.sectionType === DialogTypeFeeOrDiscount.DISCOUNT ? "Discounts" : "Handling Fees";
    }

    getDisplayName(product: Fee): string {
        return this.sectionType === DialogTypeFeeOrDiscount.DISCOUNT && this.context === FeeOrDiscountContext.LINE ? product?.additionalDescription || product?.name : product?.name;
    }

    getDisplayType(product: Fee): string {
        return this.sectionType === DialogTypeFeeOrDiscount.DISCOUNT && this.context === FeeOrDiscountContext.LINE ? product?.name : product.type?.name || "";
    }

    isAmountType(product: Fee): boolean {
        return product.type?.name === this.discountConstantsProperty?.AmountDiscountType || product?.name === this.discountConstantsProperty?.AmountDiscountType;
    }

    isPercentageType(product: Fee): boolean {
        return product.type?.name === this.discountConstantsProperty?.PercentageDiscountType || product?.name === this.discountConstantsProperty?.PercentageDiscountType;
    }

    getPercentageSymbol(product: Fee): string {
        return product?.type?.description ?? product?.description ?? "%";
    }

    trackByFee(index: number, fee: Fee): number | string {
        return fee?.id ?? index;
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
